/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  '3panel': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g fill-rule="nonzero" _fill="none"><circle pid="0" cx="12" cy="12" r="12" _fill="#8300BF"/><path pid="1" d="M19.5 6.5v11h-15v-11h15zm-8.5 1H5.5v9H11v-9zm7.5 4.5H12v4.5h6.5V12zm0-4.5H12V11h6.5V7.5z" _fill="#FFF"/></g>'
  }
})
